module.exports = __webpack_public_path__ + "media/images/element/photography-6bd7224e240e1596a3a8fbff2c908c51.svg";